import { useState } from 'react'

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null)

  const faqs = [
    {
      question: 'Comment fonctionne le système de crédits ?',
      answer: 'Chaque action sur Jean-Louis consomme un nombre défini de crédits : 1 crédit pour extraire un prospect, 10 pour l\'enrichir, 1 pour envoyer un email, etc. Vos crédits sont valables 12 mois et ne se périment pas.',
    },
    {
      question: 'Puis-je essayer gratuitement ?',
      answer: 'Oui ! Vous recevez 100 crédits gratuits à l\'inscription, sans carte bancaire requise. Vous pouvez tester toutes les fonctionnalités pendant 7 jours.',
    },
    {
      question: 'Mes données sont-elles sécurisées ?',
      answer: 'Absolument. Nous sommes conformes RGPD, certifiés ISO 27001, et hébergés en France. Vos données sont chiffrées et jamais partagées avec des tiers.',
    },
    {
      question: 'Puis-je annuler à tout moment ?',
      answer: 'Oui, sans préavis ni frais. Vos crédits restants sont conservés pendant 12 mois même après annulation.',
    },
  ]

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div id="faq" className="faq-section">
      <div className="container-narrow">
        <div className="section-header">
          <h2>Questions Fréquentes</h2>
          <p className="section-description">Tout ce que vous devez savoir</p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, i) => (
            <div key={i} className={`faq-item ${openIndex === i ? 'open' : ''}`}>
              <button className="faq-question" onClick={() => toggle(i)}>
                <span>{faq.question}</span>
                <svg className="faq-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M19 9L12 16L5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
